/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControlCreate } from '../models/ControlCreate';
import type { ControlDetail } from '../models/ControlDetail';
import type { ControlEvidenceCreate } from '../models/ControlEvidenceCreate';
import type { ControlEvidenceRead } from '../models/ControlEvidenceRead';
import type { ControlHistory } from '../models/ControlHistory';
import type { ControlRead } from '../models/ControlRead';
import type { ControlTestCreate } from '../models/ControlTestCreate';
import type { ControlTestRead } from '../models/ControlTestRead';
import type { ControlUpdate } from '../models/ControlUpdate';
import type { PaginatedResponse_ControlRead_ } from '../models/PaginatedResponse_ControlRead_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControlsService {
    /**
     * Add Control Evidence
     * @returns ControlEvidenceRead Successful Response
     * @throws ApiError
     */
    public static addControlEvidenceControlsControlIdEvidencePost({
        controlId,
        requestBody,
    }: {
        controlId: number,
        requestBody: ControlEvidenceCreate,
    }): CancelablePromise<ControlEvidenceRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/controls/{control_id}/evidence',
            path: {
                'control_id': controlId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Control Evidence
     * @returns ControlEvidenceRead Successful Response
     * @throws ApiError
     */
    public static listControlEvidenceControlsControlIdEvidenceGet({
        controlId,
    }: {
        controlId: number,
    }): CancelablePromise<Array<ControlEvidenceRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/{control_id}/evidence',
            path: {
                'control_id': controlId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Control
     * @returns ControlRead Successful Response
     * @throws ApiError
     */
    public static createControlControlsPost({
        requestBody,
    }: {
        requestBody: ControlCreate,
    }): CancelablePromise<ControlRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/controls/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Controls
     * @returns PaginatedResponse_ControlRead_ Successful Response
     * @throws ApiError
     */
    public static listControlsControlsGet({
        owner,
        status,
        category,
        q,
        limit = 20,
        offset,
        sort,
    }: {
        owner?: (string | null),
        status?: (string | null),
        category?: (string | null),
        q?: (string | null),
        limit?: number,
        offset?: number,
        sort?: (string | null),
    }): CancelablePromise<PaginatedResponse_ControlRead_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/',
            query: {
                'owner': owner,
                'status': status,
                'category': category,
                'q': q,
                'limit': limit,
                'offset': offset,
                'sort': sort,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Control
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteControlControlsControlIdDelete({
        controlId,
    }: {
        controlId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/controls/{control_id}',
            path: {
                'control_id': controlId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Control
     * @returns ControlRead Successful Response
     * @throws ApiError
     */
    public static updateControlControlsControlIdPut({
        controlId,
        requestBody,
    }: {
        controlId: number,
        requestBody: ControlUpdate,
    }): CancelablePromise<ControlRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/controls/{control_id}',
            path: {
                'control_id': controlId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Control
     * @returns ControlDetail Successful Response
     * @throws ApiError
     */
    public static getControlControlsControlIdGet({
        controlId,
    }: {
        controlId: number,
    }): CancelablePromise<ControlDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/{control_id}',
            path: {
                'control_id': controlId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Control Test
     * @returns ControlTestRead Successful Response
     * @throws ApiError
     */
    public static addControlTestControlsControlIdTestsPost({
        controlId,
        requestBody,
    }: {
        controlId: number,
        requestBody: ControlTestCreate,
    }): CancelablePromise<ControlTestRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/controls/{control_id}/tests',
            path: {
                'control_id': controlId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Control Tests
     * @returns ControlTestRead Successful Response
     * @throws ApiError
     */
    public static listControlTestsControlsControlIdTestsGet({
        controlId,
    }: {
        controlId: number,
    }): CancelablePromise<Array<ControlTestRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/{control_id}/tests',
            path: {
                'control_id': controlId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Control History
     * @returns ControlHistory Successful Response
     * @throws ApiError
     */
    public static getControlHistoryControlsControlIdHistoryGet({
        controlId,
    }: {
        controlId: number,
    }): CancelablePromise<Array<ControlHistory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/{control_id}/history',
            path: {
                'control_id': controlId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
